<template>
  <div class="Error">
    <div class="Error-content">
      <ai-typo variant="heading-01" as="h1">
        {{ $t('error.page.title') }}
      </ai-typo>

      <ai-typo variant="paragraph-03-regular" as="p">
        {{ $t('booking.errors.invalid-rooms') }}
      </ai-typo>

      <div class="Error-actions">
        <ai-button
          variant="secondary"
          :label="$t('error.page.goBack')"
          class="Error-actions-action"
          @click="goBack" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const goBack = () => {
  window.history.back();
};
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/colors';

.Error-content {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: constants.$margin-01;
  background-color: colors.$neutral-100;
  min-height: calc(50dvh - constants.$header-large);
}

.Error-actions {
  margin-top: constants.$margin-01;
}

.Error-actions-action {
  &:not(:last-of-type) {
    margin-right: constants.$margin-01;
  }
}
</style>
